import type { GroupHeaderFields } from '@ms/yammer-graphql';

import type { GroupCoverImage } from '../../../state/types';

export const processGroupCoverImage: (value: GroupHeaderFields) => GroupCoverImage = ({
  id,
  coverImageUrlTemplate: backgroundUrl,
  defaultCoverImageUrlTemplate: fallbackBackgroundUrl,
  hasDefaultCoverImage,
}) => ({
  id,
  hasDefaultCoverImage,
  backgroundUrl,
  fallbackBackgroundUrl,
});
